"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Alert.default;
  }
});
Object.defineProperty(exports, "AlertTitle", {
  enumerable: true,
  get: function get() {
    return _AlertStyled.StyledAlertTitle;
  }
});
Object.defineProperty(exports, "AlertMessage", {
  enumerable: true,
  get: function get() {
    return _AlertStyled.StyledAlertMessage;
  }
});

var _Alert = _interopRequireDefault(require("./Alert"));

var _AlertStyled = require("./Alert-styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }